import { useState, useCallback } from 'react';

export interface ImageGalleryState {
  isOpen: boolean;
  images: string[];
  currentIndex: number;
}

export const useImageGallery = () => {
  const [state, setState] = useState<ImageGalleryState>({
    isOpen: false,
    images: [],
    currentIndex: 0
  });

  const openGallery = useCallback((images: string[], startIndex: number = 0) => {
    setState({
      isOpen: true,
      images,
      currentIndex: startIndex
    });
  }, []);

  const closeGallery = useCallback(() => {
    setState(prev => ({
      ...prev,
      isOpen: false
    }));
  }, []);

  const setCurrentIndex = useCallback((index: number) => {
    setState(prev => ({
      ...prev,
      currentIndex: index
    }));
  }, []);

  return {
    ...state,
    openGallery,
    closeGallery,
    setCurrentIndex
  };
};
